import { createRequest } from "src/base/http/axios";
import { METHOD } from "src/config";

const API = {
  store: (payload = {}) => {
    let method = METHOD.POST;

    return createRequest({
      method,
      endpoint: "/contacts",
      payload,
      headers: {
        "X-Request-With-Khanhnc": "enable_session",
      },
    });
  },
};

export default API;
